import { MarketCode, MarketConfig } from './types';

import { gb } from './gb';
import { se } from './se';
import { fi } from './fi';
import { fr } from './fr';
import { no } from './no';
import { nz } from './nz';
import { dk } from './dk';

export const marketConfig: Record<Exclude<MarketCode, 'te'>, MarketConfig> = {
  se,
  gb,
  fi,
  fr,
  no,
  nz,
  dk,
};
